import { createStore } from 'vuex'
import auth from "./auth";
import setting from "./setting";

const store = createStore({
    modules: {
        auth: auth,
        setting: setting,
    },
});

export default store
